import {
  CITY_THEMES,
  DEFAULT_GEOGRAPHY_SLUG,
  getGeographyTheme as getTheme,
  type CityColorSet,
  type CityComponentTokens,
  type CityMotion,
  type CityShape,
  type CityTheme,
  type CityTypescale,
  type HeroTreatment,
} from './city-theme';

export type GeographyColorSet = CityColorSet;
export type GeographyTypescale = CityTypescale;
export type GeographyShape = CityShape;
export type GeographyMotion = CityMotion;
export type GeographyComponentTokens = CityComponentTokens;
export type GeographyTheme = CityTheme;
export type GeographyHeroTreatment = HeroTreatment;

export const GEOGRAPHY_THEMES = CITY_THEMES;
export { DEFAULT_GEOGRAPHY_SLUG };

export function getGeographyTheme(slug: string): GeographyTheme {
  return getTheme(slug);
}
